import { render, staticRenderFns } from "./AdvancedFilterChip.vue?vue&type=template&id=836f3b08&"
import script from "./AdvancedFilterChip.vue?vue&type=script&lang=js&"
export * from "./AdvancedFilterChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports